import React from 'react';
import { ShieldCheckIcon, LockIcon, ZapIcon, CreditCardIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
const rows = [{
  label: '📚 MegaPack Universitario Elite (12 Tomos)',
  price: '$19.990'
}, {
  label: '🎁 Diagnóstico Anti-Recursada',
  price: 'GRATIS'
}, {
  label: '🎁 Planificador Cuatrimestral Elite',
  price: 'GRATIS'
}, {
  label: '🎁 Checklist Final sin Pánico',
  price: 'GRATIS'
}, {
  label: '🎁 Plantillas de Apuntes Inteligentes',
  price: 'GRATIS'
}, {
  label: '🎁 Prompts de IA para Estudiar Más Rápido',
  price: 'GRATIS'
}, {
  label: '🛡️ Garantía 7 días',
  price: 'INCLUIDA'
}];
const trust = [{
  icon: LockIcon,
  label: 'Pago 100% seguro'
}, {
  icon: ZapIcon,
  label: 'Acceso en 5 minutos'
}, {
  icon: ShieldCheckIcon,
  label: 'Garantía 7 días'
}, {
  icon: CreditCardIcon,
  label: 'Mercado Pago · Tarjeta'
}];
export function ValueStack() {
  return <section id="value" aria-label="Resumen de la oferta" className="bg-ink-2 border-y border-white/5" data-id="element-203" data-mp="35pd4rm7gorhs">
      <div className="mx-auto max-w-2xl px-5 py-20 text-center pb-[21px] pt-[32px]" style={{
      paddingTop: "9px"
    }} data-id="element-204" data-mp="1tgeli5i3pywd">
        <h2 className="font-display text-2xl font-black text-white sm:text-4xl" data-id="element-205" data-mp="1ohl8ee6q89wq">
          🚀 Empezá a aprobar desde hoy
        </h2>
        <p className="mt-3 text-sm text-white/60" style={{
        paddingTop: "25px",
        marginTop: "-20px",
        marginBottom: "-20px",
        textAlign: "center"
      }} data-id="element-206" data-mp="236zhrmaayrc4">
          Por menos de lo que vale una fotocopia de apuntes tenes acceso de por vida. Todo el sistema listo para aplicar en minutos.
        </p>

        <div className="mt-10 overflow-hidden rounded-2xl border border-white/10 bg-ink text-left" data-id="element-207" data-mp="286lrhlqx9pg6">
          <div className="flex items-center justify-between border-b border-white/10 px-5 py-3 text-xs font-bold uppercase tracking-wide text-white/50" data-id="element-208" data-mp="2m1o7j1phgv6p">
            <span data-id="element-209" data-mp="rqsmv110xpnk">Qué incluye</span>
            <span data-id="element-210" data-mp="rs3tr9prndiw">Precio</span>
          </div>
          {rows.map(r => <div key={r.label} className="flex items-center justify-between gap-4 border-b border-white/5 px-5 py-3.5 text-sm" data-id="element-211" data-mp="ms7ybyv4wuey">
              <span className="text-white/80" data-id="element-212" data-mp="2mv8u65lv7gaz">{r.label}</span>
              <span className={r.price.startsWith('$') ? 'shrink-0 font-bold text-white' : 'shrink-0 font-bold text-gold'} data-id="element-213" data-mp="2rtaaiirwp1ir">
                {r.price}
              </span>
            </div>)}
          <div className="flex flex-wrap items-center justify-between gap-2 bg-verde/10 px-5 py-4" data-id="element-214" data-mp="30t7674cpr0nb">
            <span className="text-sm font-bold text-white" data-id="element-215" data-mp="35sthv9cw88u0">
              Valor total real: <span className="text-white/40 line-through" data-id="element-216" data-mp="3aqv4235m8o9p">$101.940</span>
            </span>
            <span className="font-display text-2xl font-black text-gold-shine" data-id="element-217" data-mp="3fhtnhblwi2h6">$19.990 ARS</span>
          </div>
        </div>

        <div className="mt-9" data-id="element-218" data-mp="3jjom28cg61r9">
          <CTAButton href="https://megapack-universitario-elite.impultienda.ar/checkout" data-id="element-219" data-mp="3jiwwpf9g109f">
            Sí, quiero aprobar sin recursar
          </CTAButton>
        </div>

        <div className="mt-8 flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-xs font-medium text-white/50" data-id="element-220" data-mp="3tgt6a2mqfn5f">
          {trust.map(({
          icon: Icon,
          label
        }) => <span key={label} className="inline-flex items-center gap-1.5" data-id="element-221" data-mp="2hc1w16vdps4">
              <Icon className="h-4 w-4 text-gold" data-id="element-222" data-mp="2jey52ym8f5a" />
              {label}
            </span>)}
        </div>
      </div>
    </section>;
}